import React, { useContext } from "react";

//material ui
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { PrimaryButton } from "../../materialUiComponents";
import Button from "@material-ui/core/Button";

//global state
import { StateContext } from "../../AppStateContext";

//styling
import "../../Styles/GeneralModal.scss";

const GeneralModal = ({
  modalDescription,
  title,
  text,
  actionText,
  cancelText,
  actionFunction,
  cancelFunction,
  closeModal,
  open,
  id,
  actionButtonId,
  inputValue,
  linkURL,
  link,
  small,
  noAction,
  noActionText,
  noActionFunction,
}) => {
  //global state
  const state = useContext(StateContext);

  //handles closing the modal
  const handleClose = () => {
    closeModal();
  };

  //handles the cancel button
  const handleCancel = () => {
    cancelFunction();
  };

  //handles the action button
  const handleAction = () => {
    actionFunction();
  };

  return (
    <>
      <Modal
        aria-labelledby="Weaviate console dialog modal"
        aria-describedby={modalDescription}
        disableScrollLock
        keepMounted
        className="__Modal"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className="__modalContent" style={{ background: state.theme === "dark" ? "#122742" : "#fff" }} id={id}>
            <div className="__modalDescription">
              <h3 style={{ color: state.theme === "dark" ? "#fff" : "#00152b" }} className="__modalTitle">
                {title}
              </h3>
              <h5 style={{ color: state.theme === "dark" ? "#fff" : "#00152b" }} className="__modalText">
                {text}{" "}
                {link ? (
                  <a
                    className="__linkText"
                    href={linkURL}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: state.theme === "dark" ? "#fff" : "#00152b",
                    }}
                  >
                    {link}
                  </a>
                ) : null}
              </h5>

              {inputValue ? (
                <input
                  type="text"
                  value={inputValue}
                  className="__inputText"
                  readOnly
                  style={
                    state.theme === "dark"
                      ? { color: "#fff", background: "#00152b" }
                      : { color: "#00152b", border: "1px solid #00152b" }
                  }
                />
              ) : null}
              {small ? (
                <small className="__smallText" style={{ color: state.theme === "dark" ? "#fff" : "#00152b" }}>
                  {small}
                </small>
              ) : null}
            </div>

            <div className="__modalActions">
              {cancelText ? (
                <Button
                  style={{ color: state.theme === "dark" ? "#fff" : "#00152b" }}
                  className="__modalCancel"
                  onClick={handleCancel}
                >
                  {cancelText}
                </Button>
              ) : null}

              {noAction ? (
                <PrimaryButton
                  id="no-action-button-general-modal"
                  className="__modalAction "
                  onClick={noActionFunction}
                >
                  {noActionText}
                </PrimaryButton>
              ) : null}

              <PrimaryButton id={actionButtonId} className="__modalAction" onClick={handleAction}>
                {actionText}
              </PrimaryButton>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default GeneralModal;
